/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync>): BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync(), model);
        BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync>): BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.newInstance(<BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
